import { api } from '../api';

export const get = (queryString: string) => api.get(`/audit?${queryString}`);

export const saveClientBrowserDetails = (details: IPortalClientsAuditCreate) =>
    api.post('/audit/browser', { ...details });
